import React from 'react';
import { Link } from 'react-router-dom';

export default class FormFooterLink extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="FormFooterLink">
				<div className="row">
					<div className="col-sm-12">
						<Link to={this.props.path}>{this.props.text}</Link>
					</div>
				</div>
			</div>
		);
	}
}
